module.exports = __webpack_public_path__ + "img/cardiovascular_intro.3584253f.jpg";